import { LightModePalette, LightModeTypography } from './LightMode';

export const getPalette = () => ({
  palette: {
    mode: 'light' as const,
    ...LightModePalette,
  },
  typography: {
    ...LightModeTypography,
  }
});
